const isMissing = (value) => !String(value || "").trim();

const isInvalidNonNegativeNumber = (value) => {
  if (isMissing(value)) {
    return true;
  }

  const parsed = Number(value);
  return !Number.isFinite(parsed) || parsed < 0;
};

export const validateInvoice = (invoice) => {
  const messages = [];

  if (isMissing(invoice.client.name)) {
    messages.push("Client or company name is required.");
  }

  if (isMissing(invoice.info.invoiceNumber)) {
    messages.push("Invoice number is required.");
  }

  if (isMissing(invoice.info.issueDate)) {
    messages.push("Issue date is required.");
  }

  if (isMissing(invoice.info.currencySymbol)) {
    messages.push("Currency symbol is required.");
  }

  if (isMissing(invoice.info.currencyName)) {
    messages.push("Currency name is required.");
  }

  if (!invoice.items.length) {
    messages.push("At least one invoice item is required.");
  }

  invoice.items.forEach((item, index) => {
    const row = index + 1;

    if (isMissing(item.description)) {
      messages.push(`Item ${row} description is required.`);
    }

    if (isInvalidNonNegativeNumber(item.rate)) {
      messages.push(`Item ${row} rate must be zero or greater.`);
    }

    if (isInvalidNonNegativeNumber(item.quantity)) {
      messages.push(`Item ${row} quantity must be zero or greater.`);
    }
  });

  return messages;
};
